import { Form } from "formik";
import styled from "styled-components";

import colors from "@src/common/styles/colors";
import { DEFAULT_MARGIN_M, DEFAULT_MARGIN_S } from "@src/common/styles/const";

export const ImagesRangeWrapper = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  gap: ${DEFAULT_MARGIN_S}px;
  margin-top: ${DEFAULT_MARGIN_M}px;
`;

export const ImagesRangeFormWrapper = styled(Form)`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: ${DEFAULT_MARGIN_M}px;
  height: 30px;
`;

export const InputDescription = styled.span`
  font-size: 12px;
  color: ${colors.gray3};
`;

export const RangeValue = styled(InputDescription)`
  width: 60px;
`;

export const ImagesRangeDescription = styled.p`
  grid-column: 1/3;
  font-size: 12px;
`;
